import { compose } from 'redux';
import { connect } from 'react-redux';
import * as Actions from '../../../actions/QAListManagerment';
import QAListManagerment from '../../../pages/Admin/QAListManagerment/QAListManagerment';
import withAuth from '../../../common/WithAuth';

const mapStateToProps = (state) => ({
    listQA: state.qAListManagerment.qAList.data,
    updateSuccess: state.qAListManagerment.qAList.updateSuccess,
    createSuccess: state.qAListManagerment.qAList.createSuccess,
    deleteSuccess: state.qAListManagerment.qAList.deleteSuccess,
    isFetching: state.qAListManagerment.qAList.isFetching,
    errorsQA: state.qAListManagerment.qAList.errors,
    eventInfo: state.eventManagement.infoEvent.data,
});

const mapDispatchToProps = (dispatch) => ({
    fetchListQA: (params) => {
        dispatch(Actions.GetListQARequested(params));
    },

    createQA: (params) => {
        dispatch(Actions.createQARequested(params));
    },

    updatQA: (params) => {
        dispatch(Actions.updateQARequested(params));
    },

    deleteQA: (params) => {
        dispatch(Actions.deleteQARequested(params));
    },

    clear: () => {
        dispatch(Actions.clearListQA());
    },
});

export default compose(
    withAuth,
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(QAListManagerment);
